import { createContext } from "react";

const dataProviderContext = createContext<any>({
  dataProvider: null,
  setDataProvider: (provider: any) => {}
});

export default dataProviderContext;